import { Auth } from 'aws-amplify';
import { endpoint } from '@goldspotdiscoveries/auth/lib/types';

export const environment: string =
  process.env.REACT_APP_ENVIRONMENT === 'prod'
    ? ''
    : `.${process.env.REACT_APP_ENVIRONMENT}` || '';

export let api_host_suffix: string;

switch (process.env.REACT_APP_ENVIRONMENT) {
  case 'prod':
    api_host_suffix = '.api.goldspot.ca';
    break;
  case 'test':
    api_host_suffix = '.test.api.goldspot.ca';
    break;
  case 'test2':
    api_host_suffix = '.api.test2.als.app';
    break;
  default:
    api_host_suffix = '.test.api.goldspot.ca';
    break;
}

export const endpoints: endpoint[] = [
  {
    name: 'Projects',
    endpoint: `https://projects${api_host_suffix}`,
    custom_header: async () => {
      return {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        'Content-Type': 'application/json',
      };
    },
  },
  {
    name: 'Files',
    endpoint: `https://files${api_host_suffix}`,
    custom_header: async () => {
      return {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        'Content-Type': 'application/json',
      };
    },
  },
  {
    name: 'Company',
    endpoint: `https://company${api_host_suffix}`,
    custom_header: async () => {
      return {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        'Content-Type': 'application/json',
      };
    },
  },
];
